import {
    GET_EATING_HABITS_REQUEST,
    GET_EATING_HABITS_SUCCESS,
    GET_EATING_HABITS_FAILURE
} from './constants';
import axios from 'axios';
import {onRequest, onError, onSuccess} from '../../utils/helper';
import { getBaseUrl, profileLinks } from '../../utils/links';

export function getEatingHabits(token) {
    return dispatch => {
        dispatch(onRequest(GET_EATING_HABITS_REQUEST));
        let url = `${getBaseUrl()}${profileLinks.eatingHabits}`,
            options = {
                method: 'GET',
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            };
        return axios(options)
            .then(response => {
                let data = response.data && response.data.data ? response.data.data : null;
                if (data) {
                    dispatch(onSuccess(GET_EATING_HABITS_SUCCESS, data));
                } else {
                    let err = response.errors;
                    dispatch(onError(GET_EATING_HABITS_FAILURE, err));
                }
            })
            .catch(err => {
                dispatch(onError(GET_EATING_HABITS_FAILURE, err));
            });
    };
}